<template>
  <div v-if="isVisible" class="feedback-bar">
    <div class="feedback-bar-content">
      <div class="feedback-bar-left">
        <img src="@/assets/svgs/feedback_icon.svg" alt="feedback icon" />
        <div class="feedback-bar-text">
          <h4 class="feedback-bar-title">New POP Backlinks tool</h4>
          <p class="feedback-bar-description">
            Share your feedback, leave comments for our team and shape the
            future of the new tool.
          </p>
        </div>
      </div>
      <div class="feedback-bar-actions">
        <b-button class="feedback-btn" @click="handleShareFeedback">
          Share feedback
        </b-button>
        <b-button class="dismiss-btn" @click="handleDismiss">
          Dismiss
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedbackBar",
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    handleDismiss() {
       this.$store.dispatch('submitPopFeedbackAction', {
        dismiss : true,
      }).then(() => {
    this.isVisible = false;
      })
    },

    handleShareFeedback() {
      this.$router.push("/feedback");
      this.$emit("feedback-clicked");
    },
  },
};
</script>

<style src="./feedbackbar.scss" scoped lang="scss"></style>
